import { render, staticRenderFns } from "./careerResult.vue?vue&type=template&id=48ede1aa&scoped=true"
import script from "./careerResult.vue?vue&type=script&lang=js"
export * from "./careerResult.vue?vue&type=script&lang=js"
import style0 from "./careerResult.vue?vue&type=style&index=0&id=48ede1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ede1aa",
  null
  
)

export default component.exports